import React, { FC } from 'react';
import { ListItem, Grid, ListItemIcon, ListItemText, IconButton } from '@maas-components/core';
import LinkWrapper from './LinkWrapper';
import useStyles from '../styles';
import { Icon, Service } from '../../types';

export type FavoritesProps = {
    favorite: Service;
    onFavoriteRemove: (item: string) => void;
    onClose: (...args: unknown[]) => void;
    getIcon: (iconName: Icon) => JSX.Element;
    mode: 'dark' | 'light';
    RouterLink?: React.ElementType;
};

const Favorites: FC<FavoritesProps> = ({ favorite, onFavoriteRemove, onClose, getIcon, mode, RouterLink }) => {
    const classes = useStyles({ mode });

    return (
        <ListItem className={classes.menuItemFavorite}>
            <LinkWrapper mode={mode} item={favorite} RouterLink={RouterLink}>
                <Grid alignItems="center" className={classes.favoriteContent} container onClick={onClose}>
                    <ListItemIcon className={classes.menuItemIcon}>
                        {favorite.elementIcon || getIcon(favorite.icon)}
                    </ListItemIcon>
                    <ListItemText primary={favorite.name} />
                </Grid>
            </LinkWrapper>
            <ListItemIcon>
                <IconButton
                    className={classes.removeFavoriteIcon}
                    onClick={() => onFavoriteRemove(favorite.url)}
                    edge="end"
                    aria-label="comments"
                >
                    {getIcon('DeleteOutline')}
                </IconButton>
            </ListItemIcon>
        </ListItem>
    );
};

export default Favorites;
